import { Column, Entity, Index /*ManyToOne, JoinColumn */ } from 'typeorm';
import { EmailProviderType } from '../../enums';
import { BaseEntity } from './base.entity';
// import { UserEntity } from './user.entity';

@Entity('email_provider_connection')
@Index(['userId', 'provider', 'email'], { unique: true })
@Index(['userId', 'isActive'])
export class EmailProviderConnectionEntity extends BaseEntity {
	@Column({ name: 'fk_user__id', type: 'int', unsigned: true })
	public userId!: number;

	// TODO PUT THIS BACK ONCE CRM-API IS USING THE CORRECT USER ENTITY
	/*
@ManyToOne(() => UserEntity)
@JoinColumn({ name: 'fk_user__id' })
  public user!: UserEntity;
  */

	@Column({
		name: 'provider',
		type: 'enum',
		enum: EmailProviderType,
	})
	public provider!: EmailProviderType;

	@Column({ name: 'email', type: 'varchar', length: 320 })
	public email!: string;

	@Column({ name: 'token_expiry', type: 'timestamp', nullable: true })
	public tokenExpiry?: Date;

	@Column({ type: 'json', nullable: true })
	public metadata?: Record<string, any>;

	@Column({ name: 'is_active', type: 'boolean', default: true })
	public isActive!: boolean;
}
